import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { first, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class FrameListService {
  toggleEvent: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  onToggle() {
    return this.toggleEvent.asObservable();
  }

  anyOpen(...ids: string[]): Observable<boolean> {
    return this.toggleEvent.pipe(
      first(),
      map((i) => ids.some((id) => i.includes(id)))
    );
  }

  toggle(...ids: string[]) {
    this.toggleEvent.pipe(first()).subscribe((list) => {
      ids.forEach((id) => {
        if (list.includes(id)) list = list.filter((i) => i != id);
        else list.push(id);
      });
      this.toggleEvent.next(list);
    });
  }
  open(...ids: string[]) {
    this.toggleEvent.pipe(first()).subscribe((list) => {
      ids.forEach((id) => {
        if (!list.includes(id)) list.push(id);
      });
      this.toggleEvent.next(list);
    });
  }
  close(...ids: string[]) {
    this.toggleEvent.pipe(first()).subscribe((list) => {
      ids.forEach((id) => {
        if (list.includes(id)) list = list.filter((i) => i != id);
      });
      this.toggleEvent.next(list);
    });
  }

  collapseAll() {
    this.toggleEvent.next([]);
  }
}
